<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-bank_account_bank_name"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="`${required || bankAccountFilledInSignup ? 'required' : ''}`"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/signupInputMixin";
import {mapGetters} from "vuex";

export default {
  name: "BankAccountBankName",
  components: {InputWidget},
  mixins: [BaseInputMixin('bank_account.bank_name')],

  data() {
    return {
      name: 'bank_name',
      defaultLabel: this.$t("Bank Name")
    }
  },
  computed: {
    ...mapGetters(['bankAccountFilledInSignup'])
  }
}
</script>

<style scoped>

</style>
